import { Box, Container, Grid, Typography } from "@material-ui/core";
import React from "react";

export default function BuyType({ setBuyType, buyType }) {
  function handleInputChange(e, type) {
    setBuyType(type);
  }
  return (
    <Box component={"section"} className={"section-50"}>
      <Container className="container">
        <Typography className="section-heading" component={"h2"}>
          サポート方法を選ぶ
        </Typography>
        <Grid container spacing={2}>
          <Grid item md={6}>
            <Box
              className={`buy-type-card ${buyType == "TEL" ? "active" : ""}`}
              onClick={(e) => handleInputChange(e, "TEL")}
            >
              <div className="card-head">
                <Typography
                  component={"h5"}
                  className="classification-heading font-cur"
                >
                  電話サポート
                </Typography>
              </div>
              <div>
                <div className="radio-btn"></div>
                <div>
                  <Typography>
                    お気軽にお電話にてサポートをいたします。
                    ご購入後、メールで電話番号を送付します。
                  </Typography>
                  <Typography component={"span"}>
                    ※お客様の環境によって別途通話料がかかる場合がございます。
                  </Typography>
                </div>
              </div>
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box
              className={`buy-type-card ${buyType == "ONLINE" ? "active" : ""}`}
              onClick={(e) => handleInputChange(e, "ONLINE")}
            >
              <div className="card-head">
                <Typography
                  className="classification-heading font-cur"
                  component={"h5"}
                >
                  オンラインサポート
                </Typography>
              </div>
              <div>
                <div className="radio-btn"></div>
                <div>
                  <Typography>
                    相談員の顔を見ながら、相談したい方はこちらをご選択ください。
                    <br />
                    ご購入後、メールでオンラインURLを送付します。
                  </Typography>
                </div>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
